import { CommonModule, Location } from '@angular/common';
import {
  booleanAttribute,
  Component,
  inject,
  input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { LayoutStore } from '../../../stores/layout.store';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-page-modal-container',
  standalone: true,
  imports: [CommonModule],
  template: `<main
    [ngClass]="mainClass() ? mainClass() : 'bg-white'"
    class="w-screen h-[100dvh] fixed inset-0 overflow-hidden flex flex-col slide-y"
  >
    <section
      [class.safe-top]="platform === 'ios'"
      class="flex justify-between items-center w-full p-4 bg-white border-b border-gray-100"
    >
      <img
        (click)="goBack($event)"
        class="size-5 cursor-pointer"
        src="https://api.iconify.design/material-symbols:arrow-back-ios-new-rounded.svg?color=%23374151"
      />
      <ng-content select="[icons]" />
    </section>

    <section
      [ngClass]="contentClass() ? contentClass() : 'bg-white'"
      class="flex flex-col overflow-y-auto size-full rounded-t-2xl"
    >
      <ng-content />
    </section>

    <section
      [class.safe-bottom]="platform === 'ios'"
      class="w-full bg-white border-t border-gray-100"
    >
      <ng-content select="[footer]" />
    </section>
  </main> `,
  styleUrl: './page-modal-container.component.scss',
})
export class PageModalContainer implements OnInit, OnDestroy {
  readonly location = inject(Location);
  readonly router = inject(Router);
  readonly layoutStore = inject(LayoutStore);

  desktop = input(false, { transform: booleanAttribute });
  slideEnabled = input(true, { transform: booleanAttribute });
  goBackUrl = input('');
  mainClass = input('');
  contentClass = input('');
  title = input('');
  platform = Capacitor.getPlatform();

  goBack(ev?: Event) {
    ev?.stopPropagation();
    ev?.preventDefault();

    if (this.goBackUrl()) {
      this.router.navigate([this.goBackUrl()], { replaceUrl: true });
      return;
    }
    this.location.back();
  }

  ngOnInit() {
    this.layoutStore.setIsShowPageModal(true);
  }

  ngOnDestroy() {
    this.layoutStore.setIsShowPageModal(false);
  }
}
